import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';

//Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { ToastrService } from 'ngx-toastr';

//Class
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-cpp-returns-approve-reject',
  templateUrl: './cpp-returns-approve-reject.component.html',
  styleUrls: ['./cpp-returns-approve-reject.component.scss']
})
export class CppReturnsApproveRejectComponent implements OnInit, AfterViewInit {
  errorMsgs = new Array();
  //Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  productAllDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'itemNumber', 'units', 'dumpedUnits', 'uom', 'packageSize', 'notes', 'approverNotes'];
  isParent: boolean = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  returnRequestNumber: number = 0;
  returnRequestId: number = 0;
  accountEmail: string;
  readOnlyAccess: boolean = false;
  userMenuAccessList: any;
  dsmInfo: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess: boolean = false;
  createRequestAccess: boolean = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate: boolean = true;
  requestStatus: string;
  isPickupDateValid: boolean = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  breadcrumbtext: string;
  onBehalfUser: any;
  onBehalfUserName: string;
  selectedUserName: string;
  isRequestPending: boolean = true;;
  userEmailId: string;
  isAccessForApproveReject: boolean = false;

  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber: string = 'Return';
  public shippingInstructions: string;
  public selectedFreightInstruction: string;
  public selectedFreightInstructionName: string;
  public palletCount: number;
  soldToAccount: number;
  shipToAddress: string;
  soldToaccountName: string;
  soldToaddress: string;
  shipToAcnumber: string;
  soldToAcnumber: string;
  isReturnTypeForInnoculant: boolean = false;
  warningMessage: string = "";
  dsmId: string;

  private subscription = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    public cppReturnsService: CppReturnsService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.cppReturnsService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      var data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userEmailId = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).emailId;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);
          this.isReturnTypeForInnoculant = this.cppReturnsService.isReturnTypeForInnoculant
          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          //Get Return Request Id from URL
          if (this.isReturnTypeForInnoculant) {
            this.cppReturnsService.getCPPReturnsInoculantWarningMessage().subscribe((result: any) => {
              this.warningMessage = result.message;
            });
            this.getReportDistributionEmails();
          }
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x["returnRequestId"]) {
              this.returnRequestId = +x["returnRequestId"];
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }))
        }
        this.enableCreate = true;
      }
    }

    this.productAllDataSource = new MatTableDataSource([]);
    this.cppReturnsService.setEditModeStatus(false);
    this.errorMsgs = new Array();
  }

  //Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
    }
  }

  getReportDistributionEmails() {
    let emailList = []
    this.subscription.add(this.cppReturnsService.getCPPReturnsReportDistributionEmailForInoculant().subscribe((result: any) => {
      emailList = result;
      if (emailList.find(x => x.toLowerCase() == this.userEmailId.toLowerCase())) {
        this.isAccessForApproveReject = true;
      }
      else {
        this.isAccessForApproveReject = false;
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  //Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  //Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  //Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      this.breadcrumbtext = " Approve/Reject Request [" + result.returnRequestNumber + "]"
      this.cppReturnsService.setEditModeStatus(true);
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.cppReturnsService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      this.enableCreate = false;
      this.editApprovalList = result;
      if (result.cppReturnsProductList && result.cppReturnsProductList.length > 0) {
        result.cppReturnsProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.approverNotes = '';
          x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
          if (!this.isApprovalAccess && x.lineStatus == "PENDING") {
            x.isIncreaseQtyDisable = true;
            x.isDecreaseQtyDisable = true;
          }
          else if (!this.isApprovalAccess && x.lineStatus == "APPROVED") {
            x.isIncreaseQtyDisable = true;
          }
          if (this.isReturnTypeForInnoculant) {
            if (x.isIPConfigured && x.returnQuantity > x.eligibleUnit) { x.isShowInoculantWarning = true }
            else { x.isShowInoculantWarning = false }
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      this.cppReturnsService.setSelectedAccountNo(this.shipToAccount);
      this.dsmId = result.dsmId
      this.dsmInfo = result.dsmName;
      this.isParent = result.isParent;
      this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
      this.cppReturnsService.setProductList(result.cppReturnsProductList);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.cppReturnsProductList, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.cppReturnsProductList));
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);

      this.cppReturnsService.setSelectedAccountNo(result.shipToAccountId);
      var approvedItem = result.cppReturnsProductList.filter(x => x.lineStatus == 'APPROVED');
      if (approvedItem.length > 0) {
        this.isRequestPending = false;
      }

      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.palletCount = result.pickupInfo.palletCount;
      this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
      this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;
      this.shipToAddress = result.shipToAccount.address1;
      this.soldToaccountName = result.soldToAccount.accountName;
      this.soldToaddress = result.soldToAccount.address1;
      this.soldToAcnumber = result.soldToAccount.accountNumber;
      this.shipToAcnumber = result.shipToAccount.accountNumber;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    var self = this;
    this.subscription.add(this.cppReturnsService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          var accountNameArr = x.userName.split(",");
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + " " + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;
        //if (this.currentRequestedUser) {
        //  let requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
        //  this.requestedByUser = requestItem[0].userId;
        //}
        if (this.onBehalfUser) {
          let requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          if (requestItem && requestItem.length > 0) {
            this.onBehalfUserName = requestItem[0].userName;
            this.accountEmail = requestItem[0].userEmail;
            this.requestedByUser = requestItem[0].userId;
          }
        }
        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  validateOrder() {
    var isValidatedCount = 0;
    if (this.productAllDataSource.data && this.productAllDataSource.data.length > 0) {
      this.productAllDataSource.data.forEach(x => {
        if ((x.approverNotes == null || x.approverNotes == undefined || x.approverNotes == "") && x.isIPConfigured && x.isShowInoculantWarning) {
          isValidatedCount = isValidatedCount + 1;
        }
      });
    }
    return isValidatedCount > 0 ? false : true;
  }

  backToReturnList() {
    if (this.isReturnTypeForInnoculant) {
      this.router.navigate([`/cpp-returns/dashboard-products/Inoculant`]);
    }
    else {
      this.router.navigate([`/cpp-returns/dashboard-products`]);
    }
  }

  approvedJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    //if (!this.validateOrder()) {
    //  this.toastrService.error("Approver Notes can't be Blank");
    //  return false
    //}
    var newLineItems = [];
    this.editApprovalList.isUpdateRequest = true;
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'APPROVED'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));

    let item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    this.editApprovalList.cppReturnProductList = productList;
    //this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    this.editApprovalList.returnRequestStatus = 'APPROVED';
    this.editApprovalList.PickupInfo = {
      RequestDate: this.desiredPickupDate,
      ContactName: this.contactName,
      ContactNumber: this.contactNumber,
      PickUpLocation: this.deliveryAccount,
      ShippingInstructions: this.shippingInstructions,
      FreightInstructions: this.selectedFreightInstruction,
      PalletCount: Number(this.palletCount)
    };
    //var isValidated = true;
    //if (this.validateJDEOrder()) {
    //var acceptedItem = productList.filter(x => x.lineStatus === 'APPROVED')[0];
    //if (acceptedItem === undefined) {
    //  this.toastrService.error('There is no approved line to Submit ');
    //  return;
    //}
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.submitToJDEReturnRequest(this.editApprovalList).subscribe((result: any) => {
      if (result) {
        let errorCount = result.cppReturnProductList.filter(x => x.errorMessage != null).length;
        if (errorCount > 0) {
          this.productAllDataSource.data = result.cppReturnProductList;
          this.productAllDataSource.data.forEach(x => {
            let item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
            if (item.length > 0) {
              x.lineStatus = item[0].lineStatus;
            }
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineError = x.lineError;
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            //this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            if (x.errorMessage != '' && x.errorMessage != null) {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [{ "error": x.errorMessage }] };
              x.lineError = true;
              this.errorMsgs.push(x.lineErrors);
            }
            else {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
              x.lineError = true;
            }
          });
          this.loaderService.setLoaderStatus(false);
        } else {
          let successMsg = "Inoculant return request has been approved."
          this.toastrService.success(successMsg);
          this.router.navigate([`/cpp-returns/products-confirmation/${this.returnRequestId}`]);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Inoculant return request not saved in the system.");
    }));
    //}
  }

  rejectedJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    //if (!this.validateOrder()) {
    //  this.toastrService.error("Approver Notes can't be Blank");
    //  return false
    //}
    var newLineItems = [];
    this.editApprovalList.isUpdateRequest = true;
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'REJECTED'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));

    let item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    this.editApprovalList.cppReturnProductList = productList;
    //this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    this.editApprovalList.returnRequestStatus = 'REJECTED';
    this.editApprovalList.PickupInfo = {
      RequestDate: this.desiredPickupDate,
      ContactName: this.contactName,
      ContactNumber: this.contactNumber,
      PickUpLocation: this.deliveryAccount,
      ShippingInstructions: this.shippingInstructions,
      FreightInstructions: this.selectedFreightInstruction,
      PalletCount: Number(this.palletCount)
    };
    //var isValidated = true;
    //if (this.validateJDEOrder()) {
    //var acceptedItem = productList.filter(x => x.lineStatus === 'APPROVED')[0];
    //if (acceptedItem === undefined) {
    //  this.toastrService.error('There is no approved line to Submit ');
    //  return;
    //}
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppReturnsService.submitToJDEReturnRequest(this.editApprovalList).subscribe((result: any) => {
      if (result) {
        let errorCount = result.cppReturnProductList.filter(x => x.errorMessage != null).length;
        if (errorCount > 0) {
          this.productAllDataSource.data = result.cppReturnProductList;
          this.productAllDataSource.data.forEach(x => {
            let item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
            if (item.length > 0) {
              x.lineStatus = item[0].lineStatus;
            }
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineError = x.lineError;
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            //this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            if (x.errorMessage != '' && x.errorMessage != null) {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [{ "error": x.errorMessage }] };
              x.lineError = true;
              this.errorMsgs.push(x.lineErrors);
            }
            else {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
              x.lineError = true;
            }
          });
          this.loaderService.setLoaderStatus(false);
        } else {
          let successMsg = "Inoculant return request has been rejected."
          this.toastrService.success(successMsg);
          this.router.navigate([`/cpp-returns/products-confirmation/${this.returnRequestId}`]);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Inoculant return request not saved in the system.");
    }));
    //}
  }

  returnToDraft() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    //if (!this.validateOrder()) {
    //  this.toastrService.error("Approver Notes can't be Blank");
    //  return false
    //}
    var newLineItems = [];
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'DRAFT'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    var postData = {
      ReturnRequestCppId: this.returnRequestId,
      ReturnRequestType: this.isReturnTypeForInnoculant ? 'INOCULANT' : 'PRODUCTS',
      ReturnRequestStatus: 'DRAFT',
      CompanyCode: this.headerCompany,
      ShipToAccountId: this.shipToAccount,
      IsUpdateRequest: this.cppReturnsService.getEditModeStatus(),
      DsmId: this.dsmId,
      BranchPlant: null,
      CPPReturnProductList: productList,
      Email: this.accountEmail,
      RequestedBy: this.requestedByUser,
      isReturnToDraft: "1",
      PickupInfo: {
        RequestDate: (this.desiredPickupDate ? (new Date(this.desiredPickupDate)).toLocaleDateString('en-US').replace(/\u200E/g, '') : null),
        ContactName: (this.contactName ? this.contactName : ""),
        ContactNumber: (this.contactNumber ? this.contactNumber : ""),
        PickUpLocation: (this.deliveryAccount ? this.deliveryAccount : null),
        ShippingInstructions: (this.shippingInstructions ? this.shippingInstructions : null),
        FreightInstructions: this.selectedFreightInstruction,
        PalletCount: (this.palletCount ? Number(this.palletCount) : null),
        CustPONumber: (this.customerPONumber ? this.customerPONumber : "")
      },
    }
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.cppReturnsService.submitReturnRequest(postData).subscribe((result: any) => {
      if (result) {
        if (result.errors.length > 0) {
          this.loaderService.setLoaderStatus(false);
          result.errors.forEach(x => {
            this.toastrService.error(x);
            return false;
          });
        }
        else {
          let errorCount = result.cppReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.cppReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              let item = newLineItems.filter(y => y.itemId == x.itemId);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { "itemId": x.itemId, "errors": [{ "error": x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { "itemId": x.itemId, "errors": [] };
              }
            });
            this.loaderService.setLoaderStatus(false);
          } else {
            let successMsg = "Inoculant return request has been return to draft."
            this.toastrService.success(successMsg);
            this.router.navigate([`/cpp-returns/dashboard-products/Inoculant`]);
            this.loaderService.setLoaderStatus(false);
          }
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Inoculant return request not saved in the system.");
    }));
  }

  // On page destroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
